var _defs, _style, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuarterlyIconH(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ChatGPT Image Aug 18, 2025, 07_38_12 PM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 24,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAAXNSR0IB2cksfwAAAWhQTFRFAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYAHDYODF7FAAAAHh0Uk5TAI/1eAZF874cCRAr+ZjoNL2k62wMZsDO1v42/NfP9E/kyVkEP/GlfZX2lHy2kI6L7tPZp9VRfj4pFJZhBYWSKpfpnkChhFytD9EH4tzgL06ypgKiwQHnTQqzzXGfnYbvIANt0CbhJUK8gm8YZESDkTIOxvLe3e0L/LCWXQAAAVlJREFUeJxjZAABRiD4A2YxsAKZP0BCDAycjGDwGyLBBmR+53oDlBBlhEqw/QJJsDP+4PzOBeSrgAQ/MvIz/gWKsvxh+fr/H/9vtpv/GfUYr/7hUmNkvPYDYpQx41ee0wy8sowafKcYGMyvaZ+AiDNYAg04wmB7gVFDDGQ0O8NPBvafYAYQ/GQ/Z8yocY8DbMJZEALRYOqHFaMVByMDOngoz/gHYgcGcP2NKeF2Q5Nxh+sJTAnPp9K37yDp8HoocxDkFRZ3oHs3IenwP2vCuJ6BIYiRcb+g4WqEjqAn4ofdGBkfKjC+24FsOUv4J36gEZee2XMtQLgqcafHvRvmQvODOK+rc82FOBdsRwrj82Mh71czMKSf/Wc2A8kfUi/S/8wGcUOFmBmnIkmwZDyVmUzY52CQd4kx/5rMfEwJfUHGpN3BEzDERTjcGAsZGW+pA9mM/5EkmO4pAwDflHa4AmXh2AAAAABJRU5ErkJggg=="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 1 copy 2",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuarterlyIconH);
export default __webpack_public_path__ + "static/media/quarterly-icon-h.006e17b6d405c393b67571849c95ed67.svg";
export { ForwardRef as ReactComponent };